import { InputText } from "primereact/inputtext";
import { Calendar } from 'primereact/calendar';
import { Button } from "primereact/button";
import React, { useEffect, useState, useRef, useContext } from "react";
import TextInput from "./TextInput";
import { TabPanel, TabView } from "primereact/tabview";
import { Dialog } from "primereact/dialog";
import { Dropdown } from "primereact/dropdown";
import { eventService } from "../services/EventService";
import { lookupsService } from "../services/LookupsService";
import { Toolbar } from "primereact/toolbar";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import { formatDate } from "../config/Config";
import { votersService } from "../services/VotersService";
import AddEventDelimitationStaff from "../componets/AddEventDelimitationStaff";
import { PrintOut } from "../pages/reports/PrintOut";
import { reportService } from "../services/ReportService";
import { AppDB } from "../App";
import { permissionLookUp } from "../constants";
import MultiFilterSearch from "./MultiFilterSearch";
import AddEventPareameters from "../componets/AddEventPareameters";

export default function EditByElection({ GetAllEvents, selectedParantEvent = null, selectedEvent = null, eventGroup = null, setData = [], buttonIcon = "pi pi-save", show = false, setShow, eventTypes }) {
	var [showSearchElector, setShowSearchElector] = useState(false);
	const [savedEventParameters, setSavedEventParameters] = useState([]);
	const [selectedEventClone, setCelectedEventClone] = useState();
	const [eventStaff, setEventStaff] = useState([]);
	var [showEventDelimitationStaffForm, setShowEventDelimitationStaffForm] = useState(false);
	var [loading, setLoading] = useState(false);
	const [isLoading, setisLoading] = useState(false)
	var [screenLoading, setScreenLoading] = useState(false);
	const [activeIndex, setActiveIndex] = useState(0);
	const { toast, permission } = useContext(AppDB);
	const [showAddParameterForm, setShowAddParameterForm] = useState(false);
	const [parametersList, setParametersList] = useState([]);
	var [form, setForm] = useState({ idNumber: "" });
	// const  eventDetails = [
	// 	{
	// 		col1: "Event Name",
	// 		col2: selectedEventClone?.name,
	// 		col3: "Description:",
	// 		col4: selectedEventClone?.description
	// 	},
	// 	{
	// 		col1: "Type",
	// 		col2: selectedEventClone?.eventTypeName,
	// 		col3: "Category",
	// 		col4: selectedEventClone?.EventCategoryName
	// 	}
	// ];

	var [voterForm, setVoterForm] = useState({
		Surname: "",
		Firstname: "",
		IDNumber: "",
		RegistrationNumber: "",
		ContactNumber: "",
		GenderID: "",
		EmailAddress: "",
		Address: "",
		DateAppointed: "",
		StaffTypeID: "",
		DelimitationLevelID: "",
		DelimitationID: "",
		EventDelimitationID: selectedEvent?.eventDelimitationId,
		RoleId: "",
		EventID: selectedEvent?.eventID,
		StartDate: "",
		EndDate: ""
		// "binaryData": []
	});

	const [voterData, setVoterData] = useState(null)
	var [formErrorMessage, setFormErrorMessage] = useState({
		"Surname": "",
		"Firstname": "",
		"IDNumber": "",
		"RegistrationNumber": "",
		"ContactNumber": "",
		"GenderID": "",
		"EmailAddress": "",
		"Address": "",
		"DateAppointed": "",
		"StaffTypeID": "",
		"DelimitationLevelID": "",
		"DelimitationID": "",
		"EventDelimitationID": "",
		"RoleId": "",
		"EventID": ""
		// "binaryData": []
	});

	function FormValitation() {
    let valid = true;

    Object.keys(voterForm).forEach(key => {
        // Skip validation for EmailAddress
        if (key === "EmailAddress") {
            setFormErrorMessage(form => ({ ...form, [key]: "" }));
            return;
        }

        // Validate all other fields
        if (!voterForm[key]) {
            setFormErrorMessage(form => ({ ...form, [key]: "Required." }));
            valid = false;
        } else {
            setFormErrorMessage(form => ({ ...form, [key]: "" }));
        }
    });

    return valid;
}



	function OnInputValidation(key, value = "", submitClick = false) {
		var valid = true;


		if (submitClick) {
			value = voterForm[key];
		}
	
		
		if (!value) {
			setFormErrorMessage(form => ({ ...form, [key]: "Required." }));
			valid = false;
		}
		else {
			setFormErrorMessage(form => ({ ...form, [key]: "" }));
		}

		if (valid && key == "IDNumber" && value.length != 12) {
			setFormErrorMessage(form => ({ ...form, IDNumber: "Invalid ID Number." }));
			valid = false;
		}

		return valid;
	}
	function SearchElector() {
		if (!OnInputValidation("IDNumber", "", true)) {
			return;
		}
		votersService.getByIDNumber(voterForm.IDNumber).then(res => {
			if (res) {
				var email = res.contactDetails.filter(e => e.contactType.name === "Email")?.at(0)?.contactDetail || ""
				var cell1 = res.contactDetails.filter(e => e.contactType.name === "Cellphone")?.at(0)?.contactDetail || ""
				var cell1Code = res.contactDetails.filter(e => e.contactType.name === "Cellphone")?.at(0)?.countryCode?.countryCodeID || ""

				setVoterForm({
					"Surname": res.surname,
					"Firstname": res.firstname,
					"IDNumber": voterForm.IDNumber,
					"RegistrationNumber": res?.registrationNumber,
					"ContactNumber": `+${cell1Code}${cell1}`,
					"GenderID": res.genderID,
					"EmailAddress": email,
					"Address": "",
					"DateAppointed": "",
					"StaffTypeID": "",
					"DelimitationLevelID": "",
					"DelimitationID": "",
					"EventDelimitationID": selectedEventClone?.eventDelimitationId,
					"RoleId": "",
					"EventID": selectedEventClone?.eventID
				});
				if (res?.eligibleStatus === "Y") {
					setShowSearchElector(false);
					setShowEventDelimitationStaffForm(true)
				}
				else {
					return toast.show({
						severity: "error",
						summary: "Message",
						detail: "Elector not eligible to vote.",
						life: 3000
					});
				}
			} else {
				return toast.show({
					severity: "error",
					summary: "Message",
					detail: "Elector not found.",
					life: 3000
				});
			}
		})
	}
	async function GetEventStaff() {

		eventService.getAllEventStaff({
			"eventID": selectedEvent?.eventID,
			"DelimitationID": selectedParantEvent?.eventDelimitationId,
			"DelimitationLevelID": selectedParantEvent?.eventDelimitationLevelId,
			"PageIndex": 1,
			"PageSize": 10000
		})
			.then((response) => {
				setEventStaff(response);
			})
			.catch((err) => {
				console.log(err);
				return toast.show({
					severity: "error",
					summary: "Error Message",
					detail: "There is a technical problem fetching event staff, Please Try Again",
					life: 3000
				});
			});
	};
	function SubmitForm() {
		if (!FormValitation()) {
			return;
		}
		eventService
			.createStaff(voterForm)
			.then((res) => {


				if (res?.success) {
					setVoterForm({});
					setFormErrorMessage({});
					GetEventStaff();
					setShowEventDelimitationStaffForm(false);
				}

				return toast.show({
					severity: res?.success ? "success" : "error",
					summary: "Message",
					detail: res?.message,
					life: 2000
				});
			})
			.catch((err) => {
				console.log(err)
				return toast.show({
					severity: "error",
					summary: "Error Message",
					detail: "Ooops, The is a technical problem,Please Try Again",
					life: 3000
				});
			});
	}
	function GetSavedSavedEventParameters() {
		eventService.getSavedEventParameters({
			"eventID": selectedEvent?.eventID,
			// "DelimitationID":selectedParantEvent?.eventDelimitationId,
			// "DelimitationLevelID":selectedParantEvent?.eventDelimitationLevelId,			
			"IsOneDemarcationEvent": true,
			"PageIndex": 1,
			"PageSize": 10000
		})
			.then((response) => {
				setSavedEventParameters(response);
			})
			.catch((err) => {
				console.log(err);
				return toast.show({
					severity: "error",
					summary: "Error Message",
					detail: "There is a technical problem fetching event staff, Please Try Again",
					life: 3000
				});
			});
	}
	function DeleteStaff(data) {

		setLoading(true)
		var payload = {
			EventID: selectedEvent?.eventID,
			StaffID: data.staffID,
			DelimitationID: selectedEvent?.eventDelimitationId,
			EventDelimitationLevelID: selectedEvent?.eventDelimitationLevelId
		};
		eventService
			.deleteEventStaff(payload)
			.then((res) => {

				setisLoading(false)

				if (res?.success) {
					GetEventStaff();
				}
				setScreenLoading(false);
				return toast.show({
					severity: res?.success ? "success" : "error",
					summary: "Message",
					detail: res?.message,
					life: 2000
				});
			})
			.catch((err) => {
				console.log(err)
				setScreenLoading(false);
				return toast.show({
					severity: "error",
					summary: "Error Message",
					detail: "Ooops, The is a technical problem,Please Try Again",
					life: 3000
				});
			});
	}
	const [base64, setBase64] = useState(null);
	const [showReportDialog, setReportShowDialog] = useState(false);
	const getReport = () => {
		var payload = {
			ReportID: activeIndex == 0 ? 12 : 13,
			eventid: selectedEvent.eventID,
			DelimitationLevelID: selectedEvent?.eventDelimitationLevelId,
			DelimitationID: selectedEvent?.eventDelimitationId,
			IncludeSubdelimitations: true
		};
		setisLoading(true)
		reportService.getReport(payload).then((response) => {

			setisLoading(false);

			if (response?.success) {
				setReportShowDialog(true);
				setBase64(response.data);
				toast.show({ severity: "success", summary: "", detail: response.message, life: 3000 });
			} else {
				toast.show({ severity: "error", summary: "Message", detail: "No data found", life: 3000 });
			}
		})
			.catch((err) => {
				console.log(err);
				setisLoading(false);
				return toast.show({ severity: "error", summary: "Message", detail: "Something went wrong.", life: 3000 });
			});
	};

	console.log(selectedParantEvent)
	console.log(selectedEvent)


	const [eventDetails, setEventDetails] = useState({
		eventID: selectedEvent?.eventID,
		name: selectedEventClone?.name,
		description: selectedEventClone?.description,
	});

	useEffect(() => {
		if (selectedEventClone) {
			setEventDetails({
				eventID: selectedEvent?.eventID,
				name: selectedEventClone.name,
				description: selectedEventClone.description,
			});
		}
	}, [selectedEventClone]);
	const EditEventByElection = () => {
		setisLoading(true);
		eventService
			.editEvent(eventDetails)
			.then((response) => {
				setisLoading(false);
				GetAllEvents();
				if (response?.success) {
					setCelectedEventClone((prev) => ({
						...prev,
						eventID: selectedEvent?.eventID,
						eventName: eventDetails.name,
						name: eventDetails.name,
						description: eventDetails.description,
						eventDelimitationLevelId: prev?.eventDelimitationLevelId
					}));

				}

				return toast.show({
					severity: response?.success ? "success" : "error",
					summary: "Message",
					detail: response?.message,
					life: 3000
				});
			})
			.catch((err) => {
				console.log(err);
				setisLoading(false);
				return toast.show({
					severity: "error",
					summary: "Error Message",
					detail: "There is a technical problem, Please Try Again",
					life: 3000
				});
			});
	}
	return (
		<>

			<Dialog
				visible={showSearchElector}
				onHide={() => setShowSearchElector(false)}
				header="Search Elector"
				modal
				style={{ maxWidth: "500px", width: "100%" }}
				footer={
					<>
						<Button
							loading={loading}
							className="p-button-danger" label="Cancel"
							onClick={() => (false)}
						/>
						<Button
							loading={loading}
							className="p-button-success" label="Search"
							onClick={() => {
								setLoading(false)
								SearchElector();
							}}
						/>
					</>
				}
			>
				<MultiFilterSearch
					label=""
					onClear={() => { }}
					onChange={(res) => {
						setShowSearchElector(false);
						// setShowSearchElector
						console.log(res)
						setVoterForm((form) => ({ ...form, IDNumber: res?.idNumber }));
						// setShowAddCorrectionDialog(true);
						SearchElector()
					}}
				/>
				{/* <div className="col-12">
					<label><b>ID Number</b></label>
					<InputText className="p-mb-1"
						style={{ width: "100%" }}
						name="idNumber"
						value={voterForm.IDNumber}
						onChange={e =>{
							OnInputValidation("IDNumber", e.target.value);
							setVoterForm(form => ({...form, IDNumber:e.target.value}))}}
						autoComplete='off'
						maxLength={12}
						required
					/>
					<label style={{ color: "red", marginBottom: "5px" }} >{formErrorMessage?.IDNumber}</label>
				</div> */}
			</Dialog>
			<Dialog
				visible={showEventDelimitationStaffForm}
				onHide={() => setShowEventDelimitationStaffForm(false)}
				header="Event Delimitation"
				modal
				style={{ width: "100%", height: "100%" }}
			>
				<AddEventDelimitationStaff
					show={showEventDelimitationStaffForm}
					setShow={setShowEventDelimitationStaffForm}
					selectedEvent={selectedEventClone}
					form={voterForm}
					setForm={setVoterForm}
					onSubmit={SubmitForm}
					formErrorMessage={formErrorMessage}
					OnInputValidation={OnInputValidation}
				/>
			</Dialog>
			<Dialog
				draggable={false}
				onShow={() => {

					setCelectedEventClone(prevClone => ({
						...selectedEvent,
						eventDelimitationId: selectedParantEvent?.eventDelimitationId,
						eventName: selectedParantEvent?.name,
						eventType: selectedParantEvent?.eventTypeName,
						categoryName: selectedParantEvent?.EventCategoryName,
						eventDelimitationLevelId: selectedParantEvent?.eventDelimitationLevelId
					}));
					GetEventStaff();
					GetSavedSavedEventParameters();
				}}
				header={
					<>
						<span>By Election: {selectedEventClone?.name}</span>
					</>
				}
				footer={
					<>
						<Button label="Print" onClick={getReport} className="p-button-primary" />
						<Button
							label="Close"
							onClick={(e) => {
								setShow(false);
								setVoterForm({});
								setFormErrorMessage({});
							}}
							className="p-button-danger"
						/>
					</>
				}
				visible={show}
				onHide={(e) => setShow(false)}
				style={{ width: "100%", height: "100%" }}
			>

				<PrintOut base64={base64} setBase64={setBase64} showDialog={showReportDialog} setShowDialog={setReportShowDialog} />
				<div className="grid">
					<div className="col-12 lg:col-12">
						{/* <section className="p-4 border rounded bg-gray-100">
						<DataTable
							className="remove-border"
							header={"Details"}
							size="small"
							scrollable={true}
							value={eventDetails}
							dataKey="id"
							style={{ width: "100%" }}
						>
							<Column style={{ width: "250px" }} field="col1" body={(e) => <b>{e.col1}</b>}></Column>
							<Column style={{ width: "250px" }} field="col2"></Column>
							<Column style={{ width: "250px" }} field="col3" body={(e) => <b>{e.col3}</b>}></Column>
							<Column field="col4"></Column>
						</DataTable>
						<br />
						</section> */}
						<section className="p-4 border rounded bg-gray-100">
							<div className="grid">
								<div className="col-12  lg:col-6">
									<TextInput
										label={<b>Name</b>}
										value={eventDetails?.name || ""}
										onChange={(e) =>
											setEventDetails((prev) => ({
												...prev,
												name: e.target.value
											}))
										}
									/>
								</div>
								<div className="col-12  lg:col-6">
									<TextInput
										label={<b>Description</b>}
										value={eventDetails?.description || ""}
										onChange={(e) =>
											setEventDetails((prev) => ({
												...prev,
												description: e.target.value
											}))
										}
									/>
								</div>
							</div>

							<div className="grid">
								<div className="col-12  lg:col-6">
									<TextInput label={<b>Category</b>} value={selectedEventClone?.eventCategoryName} disabled />
								</div>
								<div className="col-12  lg:col-6">
									<TextInput label={<b>Type</b>} value={selectedEventClone?.eventTypeName} disabled={true} />
								</div>
							</div>

							<Button
								label="Save"
								onClick={() => EditEventByElection()}
								className="p-button-success"
								icon="pi pi-pencil"
								disabled={false}
							/>
							<br />
						</section>

						<TabView activeIndex={activeIndex} onTabChange={(e) => setActiveIndex(e.index)}>
							<TabPanel header="Staff">

								{permission?.subModules?.EventStaff?.includes(permissionLookUp.Create) &&

									<Toolbar
										right={
											<div>
												<Button
													className="p-button-success mr-2"
													icon="pi pi-plus" label="Add By-Election Staff"
													onClick={() => {
														setShowSearchElector(true)
													}}
												/>
											</div>
										}
									/>}
								<DataTable
									className="remove-border"
									size="small"
									scrollable={true}
									value={eventStaff}
									dataKey="id"
									style={{ width: "100%" }}
								>
									<Column style={{ width: "250px" }} header="First Name" field="firstname" sortable></Column>
									<Column style={{ width: "250px" }} header="Surname" field="surname" sortable></Column>
									<Column style={{ width: "250px" }} header="Gender" field="genderName" sortable></Column>
									<Column style={{ width: "250px" }} header="ID Number" field="idNumber" sortable ></Column>
									{/* <Column style={{ width: "250px" }} header ="Staff Number" field="staffNumber" sortable ></Column> */}
									<Column style={{ width: "250px" }} header="Demarcation Level" field="demarcationLevelName" sortable></Column>
									<Column style={{ width: "250px" }} header="Demarcation Name" field="demarcationName" sortable></Column>
									{/* <Column
										body={(rowData) => (
											<>
												<div className="flex gap-1">
													<Button
														disabled={rowData.leaf}
														type="button"
														icon="pi pi-times"
														severity="danger"
														tooltip="Click to remove"
														rounded
														onClick={() => DeleteStaff(rowData)}
													/>
												</div>
											</>
										)}
									/> */}
									{/* <Column style={{ width: "250px" }} header ="Demarcation" field="dateAppointed" body={(e) => formatDate(e.dateAppointed)}  sortable></Column> */}
								</DataTable>
							</TabPanel>
							<TabPanel header="Parameters">
								{permission?.subModules?.ByElectionEventParameters?.includes(permissionLookUp.Create) && (
									<Toolbar
										right={
											<div>
												<Button
													className={"p-button-success mr-2"}
													icon="pi pi-plus"
													label="Add Parameters"
													onClick={() => {
														console.log(selectedEvent);
														setShowAddParameterForm(true);
													}}
												/>
											</div>
										}
									/>
								)}
								<DataTable
									className="remove-border"
									size="small"
									scrollable={true}
									value={savedEventParameters}
									dataKey="eventParameterID"
									style={{ width: "100%" }}
								>
									<Column style={{ width: "250px" }} header="Name" field="parameterName" sortable></Column>
									<Column style={{ width: "250px" }} header="Value" field="value" sortable></Column>
									<Column style={{ width: "250px" }} header="Start Date" field="startDate" body={(e) => formatDate(e.startDate)} sortable></Column>
									<Column style={{ width: "250px" }} header="End Date" field="endDate" body={(e) => formatDate(e.endDate)} sortable ></Column>
									<Column style={{ width: "250px" }} header="Created by" field="createdBy" sortable ></Column>
									<Column style={{ width: "250px" }} header="Date Created" field="createdDate" body={(e) => formatDate(e.createdDate)} sortable></Column>
								</DataTable>
							</TabPanel>

						</TabView>

					</div>
				</div>
			</Dialog>
			<Dialog
				visible={showAddParameterForm}
				onHide={() => {
					setShowAddParameterForm(false);
				}}
				style={{ height: "90%", width: "90%" }}
			>
				<AddEventPareameters
					show={showAddParameterForm}
					setShow={setShowAddParameterForm}
					parametersList={parametersList}
					setParametersList={setParametersList}
					form={form}
					setForm={setForm}
					isDelimitation={false}
					eventCategoryID={selectedEvent?.eventCategoryID}
					eventId={selectedEvent?.eventID}
					delimitationID={selectedEvent?.eventDelimitationId}
					delimitationLeveId={selectedEvent?.eventDelimitationLevelId}
					setSavedEventParameters={GetSavedSavedEventParameters}
					savedEventParameters={savedEventParameters}
					IsOneDemarcationEvent={true}
				/>
			</Dialog>
		</>
	);
}
